import styled from 'styled-components';
import * as mixins from 'view/styles/mixins';
import { HtmlButton } from '../analytics/html-button';

const UnstyledButton = styled(HtmlButton)`
    ${mixins.focusRing.default};
    cursor: pointer;
    position: relative;
    background-color: transparent;
    color: transparent;
    border: 0;
    padding: 0;

    &::-moz-focus-inner {
        border: 0;
    }
`;

export default UnstyledButton;
